import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import * as typeStyles from "@clockwise/web-commons/src/styles/type.styles";
import { CSSProperties } from "react";

const backgroundColor = greys.paleGrey;
const borderRadius = 2;
const padding = 10;

export const suggestion: CSSProperties = {
  backgroundColor,
  borderRadius,
  padding,
  lineHeight: 1.4,
  cursor: "pointer",
  fontSize: 14,
  fontFamily: typeStyles.fontFamilySans,
  display: "flex",
  flexDirection: "row",
};

export const suggestionHovered: CSSProperties = {
  ...suggestion,
  backgroundColor: greys.cloudyBlue,
};

export const suggestionSelected: CSSProperties = {
  ...suggestion,
  padding: 0,
  cursor: "auto",
  backgroundColor: greys.white,
};

export const icon = {
  htmlColor: greys.slate,
};

export const close = {
  style: {
    right: 0,
    top: -15,
  } as CSSProperties,
};

export const roomDetails = {
  container: {
    flexGrow: 3,
    width: "100%",
    alignSelf: "baseline",
  } as CSSProperties,
  name: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  } as CSSProperties,
};

export const capacity: CSSProperties = {
  fontSize: 12,
  color: greys.slate,
  marginTop: 3,
};

export const impact: CSSProperties = {
  marginTop: 3,
  fontSize: 12,
  lineHeight: 1.4,
  color: colors.peach.darker,
  display: "flex",
  flexDirection: "row",
};

export const warningIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 10,
  } as CSSProperties,
  htmlColor: colors.peach.darker,
};

// rescheduler
export const actionButtonContainer: CSSProperties = {
  padding: `0 ${padding}px ${padding}px ${padding}px`,
  borderBottomLeftRadius: borderRadius,
  borderBottomRightRadius: borderRadius,
  backgroundColor: suggestionHovered.backgroundColor,
};

export const actionButton: CSSProperties = {
  display: "block",
  boxShadow: "none",
};

export const savingProgress: CSSProperties = {
  backgroundColor: "transparent",
  position: "relative",
  marginTop: 10,
};
